/**
 * payToUs — where a customer sends money when they'd rather push it than let
 * us pull it: bank bill-pay, their own ACH, a wire, or a mailed check.
 *
 * ⚠ MIRROR of netlify/functions/_lib/brand-info.ts. Those are the values the
 * owner signed off on and they print on every invoice and statement PDF; this
 * copy exists because the client can't import a Netlify function lib, and
 * `tests/pay-to-us.test.ts` FAILS if the two ever disagree. Change the server
 * file and this one together — a customer wiring money to a stale account
 * number is not a display bug.
 */

export const PAY_TO_BANK = 'JPMorgan Chase';
export const PAY_TO_ROUTING = '322271627';
export const PAY_TO_ACCOUNT = '80006258182';
export const PAY_TO_ACCOUNT_NAME = 'Brix Beverage';

/** Checks are made out to this and mailed to the address below. */
export const CHECK_PAYABLE_TO = 'Brix Beverage';
export const MAIL_TO_LINES = [
  'Brix Beverage',
  'Hangar 25 · 1951 Monarch Street',
  'Alameda, CA 94501',
];

/**
 * The monitored inbox for remittance advice. A bank transfer reaches us as a
 * bare amount with no invoice numbers attached, so this address is the whole
 * difference between a payment we can apply and one somebody has to phone
 * about — which is why it is stated everywhere a push is offered.
 */
export const REMIT_TO_EMAIL = 'remit@alamedapointbg.com';
